import { type CurrencyFormattingOptions } from '@billy/design-system'

export const DEFAULT_CURRENCY_NUMBER_FORMAT_OPTIONS: CurrencyFormattingOptions = {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
}
